import { render, staticRenderFns } from "./SystemParameterView.vue?vue&type=template&id=ef1fe9a4"
import script from "./SystemParameterView.vue?vue&type=script&lang=js"
export * from "./SystemParameterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports